'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_RadioGroupProps = Object.assign({}, {
  /**
   * The name that will be applied to all child radio buttons.
   */
  name: require('prop-types').string,


  /**
   * Should be used to pass RadioButton or Radio components.
   */
  children: require('prop-types').any,

  /**
   * Callback function that is fired when a radio button has been checked.
   */
  onChange: require('prop-types').func,

  /**
   * The value of the currently selected radio button
   */
  value: require('prop-types').any,

  /**
   * The default selected radio button
   */
  defaultValue: require('prop-types').any
}, babelPluginFlowReactPropTypes_proptype_CommonType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_CommonType);
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RadioGroupProps', {
  value: babelPluginFlowReactPropTypes_proptype_RadioGroupProps,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RadioGroupState = {
  /**
   * The value of the currently selected radio button
   */
  value: require('prop-types').string.isRequired
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RadioGroupState', {
  value: babelPluginFlowReactPropTypes_proptype_RadioGroupState,
  configurable: true
});

var RadioGroup = function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup(props) {
    _classCallCheck(this, RadioGroup);

    var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));

    _this.isControlled = props.value != null;

    if (!_this.isControlled) {
      _this.state = {
        value: props.defaultValue
      };
    }
    return _this;
  }

  _createClass(RadioGroup, [{
    key: 'handleChange',
    value: function handleChange(e) {
      if (!this.isControlled) {
        this.setState({
          value: e.target.value
        });
      }
      if (this.props.onChange) {
        this.props.onChange(e, e.target.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          name = _props.name,
          className = _props.className,
          style = _props.style,
          valueProp = _props.value,
          children = _props.children;


      var value = this.isControlled ? valueProp : this.state.value;

      return _react2.default.createElement(
        'div',
        { className: 'radio-group ' + className, style: style },
        _react2.default.Children.map(children, function (child) {
          if (!_react2.default.isValidElement(child)) {
            return null;
          }

          return _react2.default.cloneElement(child, {
            name: name,
            checked: value === child.props.value,
            onChange: _this2.handleChange.bind(_this2)
          });
        })
      );
    }
  }]);

  return RadioGroup;
}(_react2.default.Component);

RadioGroup.propTypes = Object.assign({}, {
  name: require('prop-types').string,
  children: require('prop-types').any,
  onChange: require('prop-types').func,
  value: require('prop-types').any,
  defaultValue: require('prop-types').any
}, babelPluginFlowReactPropTypes_proptype_CommonType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_CommonType);
exports.default = RadioGroup;